import { Stack, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";

export default function RatingCard() {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      justifyContent="center"
      mt={2}
    >
      <StarIcon color="warning" />
      <Typography variant="h6" sx={{ fontFamily: '"Poppins", serif' }}>
        4.6/5 on Google
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontFamily: '"Poppins", serif' }}
      >
        38k+ Reviews
      </Typography>
    </Stack>
  );
}
